import React from 'react';
import { Box, Typography } from '@mui/material';
import PowerPlot from './PowerPlot';

const PowerCard = ({
  power,
  seriesGrid,
  seriesSolar,
  seriesCharge,
  seriesDischarge,
}) => {
  const hasPower = power != null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{
        display: "flex",
        alignItems: "baseline",
        gap: 0.75,
        height: 110,
        pt: 3,
        boxSizing: "border-box",
      }}>
        <Typography sx={{
          fontSize: 56,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: "-0.03em",
          fontVariantNumeric: "tabular-nums",
          color: hasPower ? "var(--c-brand)" : "var(--c-border-strong)",
        }}>
          {hasPower ? Number(power.toFixed(2)) : "–"}
        </Typography>
        <Typography sx={{
          fontSize: 22,
          fontWeight: 500,
          color: "var(--c-text-muted)",
          lineHeight: 1,
        }}>
          kW
        </Typography>
        <Typography sx={{ fontSize: 13, fontWeight: 500, color: "var(--c-text-faint)", lineHeight: 1, ml: 0.5 }}>
          grid now
        </Typography>
      </Box>

      <PowerPlot
        tsGrid={seriesGrid}
        tsSolar={seriesSolar}
        tsCharge={seriesCharge}
        tsDischg={seriesDischarge}
        plotHeight={220}
      />
    </Box>
  )
}

export default PowerCard;
